import { object, string } from 'yup';
import { TestQuestionBaseSchema } from './TestQuestion';

export const ESSAY_SCHEMA = TestQuestionBaseSchema.concat(
	object({
		type: string().default('essay'),
		answer_schema: string().required().default('text'),
	})
);
